// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__3ca2L","checkboxCol":"Table_checkboxCol__3xh8K","emailCol":"Table_emailCol__3Twoe","actionCol":"Table_actionCol__3hNLT"};